import { useFetchTeamsQuery } from '../../store/team/TeamApi';
import { useParams } from 'react-router';
import { CircularProgress, Grid } from "@mui/material";
import TeamDetail from "../team/TeamDetail"; 
import { Box } from '@mui/material';
import { useTheme } from '@mui/material/styles';


export default function TeamDetails({selectedYear, selectedClub})
{

  const params = useParams();
  const clubLabelParameter = params.clubLabel;
  const yearParameter = params.year;
  const theme = useTheme();

  const {data:teams, isLoading:teamsAreLoading} = useFetchTeamsQuery({
    year: yearParameter, 
    clubLabel: clubLabelParameter,
  });


  // Ausgeben der Seite mit den Teaminformationen
  if (!yearParameter||!clubLabelParameter||teamsAreLoading||!teams)
  {
    // Wir zeigen in der Mitte der Liste einfach ein Zeichen, dass
    // wir noch am Laden sind: 
    return(
      <CircularProgress />
    );
  }
  
  return (
    <>
      {
        [...teams]
        .sort((a,b) => {
          if (a.is_female !== b.is_female ) return a.is_female ? -1 : 1;
          if (a.is_u8 !== b.is_u8 ) return a.is_u8 ? -1 : 1;
          return a.counter - b.counter;
        })
        .map(
          (team, index) =>  
          (
            <Grid key={team.id} size={12}>
              <Box sx=
                {{ 
                  maxWidth: 700, 
                  mx: 'auto',
                  p:2,
                  borderRadius: 3,
                  bgcolor: index % 2 === 0 ? theme.palette.primary[50] : theme.palette.primary[100],
                  border: '1px solid',
                  mb: 1,
                }}
              >
                <TeamDetail 
                  year={selectedYear} 
                  club={selectedClub} 
                  team={team} 
                />
              </Box>
            </Grid>
          )
        )
      }
    </>      
  );
}